"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var div = document.createElement("div");
    var h2 = document.createElement("h2");
    var p = document.createElement("p");
    div.classList.add("notification");
    div.classList.add(type);
    h2.classList.add("title");
    h2.textContent = title;
    p.textContent = description;
    h2.style.whiteSpace = "nowrap";
    div.append(h2);
    div.append(p);
    div.style.top = posTop + "px";
    div.style.right = posRight + "px";
    document.body.append(div);
    setTimeout(function() {
        div.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.76cc408c.js.map
